import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDateListPayload } from '@app-store/slices/eventTopics/dateList'

interface TaskAction extends Action {
    payload: IDateListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventTopics.dateList

function* dateListSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/event/event-topic/list-dates`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* dateListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, dateListSagaTask)
}

export default dateListSaga
